import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { GeneralStoreService } from '../../stores/general-store.service';
import { Observable, combineLatest, map } from 'rxjs';
import { AccountInterface } from '../../models/account.model';
import { UserAccountStoreService } from '../../stores/user-account-store.service';
import { NgIf, AsyncPipe } from '@angular/common';
import { CardAccountDeleteComponent } from '../../cards/card-account-delete/card-account-delete.component';
import { CardAccountComponent } from '../../cards/card-account/card-account.component';
import { CardEmailComponent } from '../../cards/card-email/card-email.component';
import { CardPairingComponent } from '../../cards/card-pairing/card-pairing.component';
import { CardPasswordComponent } from '../../cards/card-password/card-password.component';
import { SideMenuExtraComponent } from '../../components/side-menu-extra/side-menu-extra.component';
import { SideMenuHelpComponent } from '../../components/side-menu-help/side-menu-help.component';
import { SideMenuComponent } from '../../components/side-menu/side-menu.component';
import { SpinnerComponent } from '../../components/spinner/spinner.component';
import { ContentTemplateInterface } from '../../models/content-template.model';

interface CookiePageData {
  isLoggedIn: boolean;
  userAccount: AccountInterface;
  content: ContentTemplateInterface | null;
}
@Component({
  selector: 'app-cookie-policy-page',
  templateUrl: './cookie-policy-page.component.html',
  styleUrls: ['./cookie-policy-page.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf, SideMenuComponent, CardAccountComponent, CardPairingComponent, CardPasswordComponent, CardEmailComponent,
    AsyncPipe, SpinnerComponent,
    CardAccountDeleteComponent,
    SideMenuHelpComponent,
    SideMenuExtraComponent
  ]
})
export class CookiePolicyPageComponent implements OnInit {

  cookiePageData$: Observable<CookiePageData>;

  private generalStore = inject(GeneralStoreService);
  private userAccountStore = inject(UserAccountStoreService);

  constructor() {
  }

  ngOnInit(): void {
    this.cookiePageData$ = combineLatest([
      this.userAccountStore.isLoggedIn$,
      this.userAccountStore.userAccount$,
      this.generalStore.getContentByCode('COOKIE_POLICY')
    ]).pipe(
      map(
        ([isLoggedIn, userAccount, content]) => {
          return {
            isLoggedIn, userAccount, content
          };
        }
      )
    );
  }
}
